import { FC } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

const StyledNoDataInfo = styled.div`
  ${tw`flex flex-col m-auto justify-center items-center h-full text-center`};
`;
const Heading = styled.h2`
  ${tw`text-textPrimary`};
`;
const Text = styled.p`
  ${tw`max-w-96 text-textSecondary`};
`;
const Image = styled.img`
  ${tw`w-20 h-20 mb-4 mt-4`};
`;

interface Props {
  heading: string;
  text: string;
  img: string;
  altText?: string;
}

const NoDataInfo: FC<Props> = ({ heading, text, img, altText }) => (
  <StyledNoDataInfo>
    <Image src={img} alt={altText} />
    <Heading>{heading}</Heading>
    <Text>{text}</Text>
  </StyledNoDataInfo>
);

export default NoDataInfo;
